// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  fetchBands,
  fetchDomains,
  fetchLicenseBases,
  fetchRadioServices,
  fetchRcnStatuses,
  fetchPathStatuses,
  fetchSegmentStatuses,
  fetchStates,
  fetchStationClasses,
} from 'helpers/api'

import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'
import { addRegulatorySettings } from 'redux/modules/domain'
import catchEmptySettings from './catchEmptySettings'

const fetchAndAddRegulatorySettings = () => async (dispatch, getState) => {
  // NOTE: there is no filtering by domain currently.
  const p = [
    fetchBands(),
    fetchDomains(),
    fetchLicenseBases(),
    fetchRadioServices(),
    fetchRcnStatuses(),
    fetchPathStatuses(),
    fetchSegmentStatuses(),
    fetchStates(),
    fetchStationClasses(),
  ]

  let r

  try {
    r = await Promise.all(p)
  } catch (err) {
    console.warn(err)
    dispatch(settingsFailedToLoadMessage('Domain', err))
  }

  const regulatorySettings = {
    bands: r[0].entities,
    domains: r[1].entities,
    licenseBases: r[2].entities,
    radioServices: r[3].entities,
    rcnStatuses: r[4].entities,
    pathStatuses: r[5].entities,
    segmentStatuses: r[6].entities,
    states: r[7].entities,
    stationClasses: r[8].entities,
  }

  dispatch(catchEmptySettings('Domain', regulatorySettings))
  dispatch(addRegulatorySettings(regulatorySettings))
}

export default fetchAndAddRegulatorySettings
